import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  loadingUpdateTrafficStatus: false,
}

const adminUserSlice = createSlice({
  name: 'adminUser',
  initialState,
  reducers: {
    updateAdminUser: (state, action) => {
      state.user = action.payload;
    },
    signInRequest: () => {},
    verifyTokenRequest: () => {},
    updateTrafficStatus: (state) => {
      state.loadingUpdateTrafficStatus = true;
    },
    updateTrafficStatusSpeech: (state) => {
      state.loadingUpdateTrafficStatus = true;
    },
    updateTrafficStatusSuccess: (state) => {
      state.loadingUpdateTrafficStatus = false;
    },
    updateTrafficStatusFailed: (state) => {
      state.loadingUpdateTrafficStatus = false;
    }
  }
})

export const {
  updateAdminUser,
  signInRequest,
  verifyTokenRequest,
  updateTrafficStatus,
  updateTrafficStatusSpeech,
  updateTrafficStatusSuccess,
  updateTrafficStatusFailed,
} = adminUserSlice.actions;

export default adminUserSlice.reducer;
